import "./player-challenge-report.css";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { capitalizeAll, convertDuration, isEmpty } from "../../../core/utils/helpers";

const PlayerChallengeReport = ({ challenge_type, report_data }) => {
  return (
    <div className="player-challenge-report">
      {isEmpty(report_data) ? (
        <p>No Data about Challenge Report available yet!</p>
      ) : (
        report_data?.map((row, idx) => {
          return (
            <div className="pcr-question-item" key={row?.question_id}>
              <div className="pcr-q-i-head">
                <span className="q-tick">Question {idx + 1}</span>
                {challenge_type === "team" && <span className="q-player">Responded by {capitalizeAll(row?.player_name)}</span>}
              </div>
              <div className="pcr-q-i-ruban">
                <div className="ruban-tile">
                  <span>Question Type</span>
                  <p>
                    {row?.type === "OCA"
                      ? "Single Choice Answer"
                      : "Multiple Choice Answers"}
                  </p>
                </div>
                <div className="ruban-tile">
                  <span>Duration</span>
                  <p>{convertDuration(row?.question_timing)}</p>
                </div>
                <div className="ruban-tile">
                  <span>Max points</span>
                  <p>{row?.question_max_points} points</p>
                </div>
                <hr />
                <div className="ruban-tile">
                  <span>Responded in</span>
                  <p>{convertDuration(row?.timing)}</p>
                </div>
                <div className="ruban-tile">
                  <span>Points won</span>
                  <p>{row?.points} points</p>
                </div>
              </div>
              <div className="pcr-q-i-description">
                <span>Question's Description</span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: row?.description,
                  }}
                />
              </div>
              <div className="pcr-q-i-explanations">
                <span>Question's Explanations</span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: row?.explanations,
                  }}
                />
              </div>
              <div className="pcr-q-i-answers">
                <span className="pcr-q-i-answers-head">Your responses</span>
                <div className="pcr-q-i-answers-content">
                  {row?.answers?.map((ans, idx) => {
                    return (
                      <div
                        className={
                          ans?.is_correct
                            ? "pcr-q-i-a-item is-correct"
                            : "pcr-q-i-a-item is-incorrect"
                        }
                        key={idx}
                      >
                        {ans.is_correct ? (
                          <BsCheckCircle className="icon is-correct" />
                        ) : (
                          <BsXCircle className="icon is-incorrect" />
                        )}

                        <p
                          dangerouslySetInnerHTML={{
                            __html: ans.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="pcr-q-i-answers">
                <span className="pcr-q-i-answers-head">Expected responses</span>
                <div className="pcr-q-i-answers-content">
                  {row?.question_answers?.map((ans, idx) => {
                    return (
                      <div
                        className={
                          ans?.is_correct
                            ? "pcr-q-i-a-item is-correct"
                            : "pcr-q-i-a-item is-incorrect"
                        }
                        key={idx}
                      >
                        {ans.is_correct ? (
                          <BsCheckCircle className="icon is-correct" />
                        ) : (
                          <BsXCircle className="icon is-incorrect" />
                        )}

                        <p
                          dangerouslySetInnerHTML={{
                            __html: ans.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default PlayerChallengeReport;
